import clsx from "clsx";

type NavItemStateParams = {
  inverted: boolean;
  disabled: boolean;
  active: boolean;
  /** Whether the item represents the current/selected state. Default: false. */
  selected?: boolean;
};

/**
 * Shared text-color, selected-background, and hover/active-background
 * classes for the footer's NavItem variants (button, link, ...).
 */
export const getNavItemStateClasses = ({
  inverted,
  disabled,
  active,
  selected = false,
}: NavItemStateParams) =>
  clsx(
    inverted
      ? disabled
        ? "text-foreground-tertiary-inverse"
        : "text-foreground-primary-inverse"
      : disabled
        ? "text-foreground-tertiary"
        : "text-foreground-primary",
    selected &&
      (inverted ? "bg-surface-tertiary-inverse" : "bg-surface-tertiary"),
    !disabled &&
      (inverted
        ? [
            "hover:bg-surface-secondary-inverse active:bg-surface-secondary-inverse",
            active && "bg-surface-secondary-inverse",
          ]
        : [
            "hover:bg-surface-secondary active:bg-surface-secondary",
            active && "bg-surface-secondary",
          ]),
  );
